<template>
    <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body">
            <b-row>
                <b-col cols="3">
                    <img v-if="klinik.foto_klinik == null" class="img-logo" src="/img/new_logo.png" alt="image body" />
                    <img v-else :src="klinik.foto_klinik" class="img-logo" alt="image body" />
                    <br />
                    {{ klinik.nama_klinik ? labelStartCase(klinik.nama_klinik) : '-' }} <br>
                    <template v-if="this.isDpm">
                      No. SIP {{ klinik.nomor_ijin || '-' }} <br>
                    </template>
                    <template v-else>
                      No. Izin {{ klinik.nomor_ijin || '-' }} <br>
                    </template>
                </b-col>
                <b-col class="text-right" cols="3" offset="6">
                    {{ klinik.alamat || '-' }} <br>
                    {{ klinik.kota_detail ? klinik.kota_detail.nama : '-' }} <br>
                    Telp. {{ klinik.nomor_telp || '-' }}
                </b-col>
            </b-row>
            <div class="d-flex flex-column">
                <div class="d-flex flex-row justify-content-center">
                    <h3 class="font-weight-bold text-uppercase">invoice</h3>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <span>No. Invoice: {{ dataStruk.no_invoice }}</span>
                </div>
                <b-row class="mb-3">
                    <b-col cols="7">
                        <b-row>
                            <b-col cols="4" class="font-weight-bold">No. RM</b-col>
                            <b-col cols="8">: {{ dataStruk.nomor_rekam_medis || '-' }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" class="font-weight-bold">Nama Pasien</b-col>
                            <b-col cols="8">: {{ dataStruk.nama ? labelStartCase(dataStruk.nama) : '-' }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" class="font-weight-bold">Poliklinik</b-col>
                            <b-col cols="8">: {{ dataStruk.poliklinik ? `${dataStruk.poliklinik} (${dataStruk.kategori})` :
                            '-' }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" class="font-weight-bold">Tenaga Medis 1</b-col>
                            <b-col cols="8">: {{ dataStruk.dokter ? labelStartCase(dataStruk.dokter) : '-' }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" class="font-weight-bold">Tenaga Medis 2</b-col>
                            <b-col cols="8">: {{ dataStruk.perawat_name ? labelStartCase(dataStruk.perawat_name) : '-' }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" class="font-weight-bold">Metode Pembayaran</b-col>
                            <b-col cols="8">
                              <b-row>
                                  <b-col cols="8" v-if="dataStruk.status == 'LUNAS'">
                                      : {{ labelMetodePembayaran(dataStruk) }}
                                  </b-col>
                                  <b-col cols="8" v-else>: -</b-col>
                              </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <div class="category-bpjs" v-if="isBpjs">
              <h4 v-if="tindakanBpjs.length > 0 || obatBpjs.length > 0" class="font-weight-bold mb-4">Ditanggung BPJS</h4>
              <!-- Tindakan BPJS -->
              <div v-if="tindakanBpjs.length > 0" class="bpjs-tindakan">
                <b-table :fields="fieldsTindakanBpjs()" :items="tindakanBpjs" show-empty borderless class="table-pembayaran-struk">
                    <template #empty="scope">
                      <div class="text-center">
                        <h4>{{ '-' }}</h4>
                      </div>
                    </template> 
                    <template v-slot:cell(tindakan)="data">
                        {{ data.item.nama_layanan }}
                    </template>
                    <template v-slot:cell(tarif)="{}">-</template>
                    <template v-slot:cell(subtotal_tarif_net)="{}">-</template>
                </b-table>
              </div>
              <!-- End Tindalan BPJS -->

              <!-- Obat BPJS -->
              <div v-if="obatBpjs.length > 0" class="bpjs-obat">
                <b-table :fields="fieldsObatBpjs()" :items="obatBpjs" show-empty borderless class="table-pembayaran-struk">
                  <template #empty="scope">
                    <div class="text-center">
                      <h4>{{ '-' }}</h4>
                    </div>
                  </template>  
                  <template v-slot:cell(obat)="data">
                        {{ data.item.nama_layanan }}
                    </template>
                    <template v-slot:cell(sedia)="data">
                      {{ data.item.bpjs_sedia || '-' }}
                    </template>
                    <template v-slot:cell(subtotal_tarif_net)="{}">-</template>
                </b-table>
              </div>
              <!-- End Obat BPJS -->
            </div>
          
            <h4 v-if="isBpjs" class="font-weight-bold mb-4 mt-50">Tidak Ditanggung BPJS</h4>
            <b-table :fields="fields()" :items="layananNormal" borderless class="table-pembayaran-struk">
                <template v-slot:cell(layanan)="data">
                  <div v-if="data.item.jenis_potongan !== '-'">
                    <div v-if="cekNilaiDiskon(data.item.potongan)">
                        {{ data.item.nama_layanan }}
                    </div>
                    <div v-else>&nbsp;</div>
                  </div>
                </template>
                <template v-slot:cell(tarif)="data">
                  <div v-if="data.item.jenis_potongan !== '-'">
                    <div v-if="cekNilaiDiskon(data.item.potongan)">
                      Rp. {{ data.item.tarif ? data.item.tarif.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : '0' }},-
                    </div>
                    <div v-else>&nbsp;</div>
                  </div>
                </template>
                <template v-slot:cell(jenis_potongan)="data">
                  <div v-if="data.item.jenis_potongan !== '-'">
                    <div v-if="cekNilaiDiskon(data.item.potongan)">
                        <span v-if="data.item.jenis_potongan == 'PERSENTASE'">%</span>
                        <span v-else-if="data.item.jenis_potongan == 'RUPIAH'">Rp.</span>
                        <span v-else>-</span>
                    </div>
                    <div v-else>&nbsp;</div>
                  </div>
                  <div v-else class="font-weight-bold"><h4>-</h4></div>
                </template>
                <template v-slot:cell(potongan)="data">
                  <div v-if="data.item.jenis_potongan !== '-'">
                    <div v-if="cekNilaiDiskon(data.item.potongan)">
                        <span v-if="data.item.jenis_potongan == 'PERSENTASE'">{{ data.item.potongan }}</span>
                        <span v-else-if="data.item.jenis_potongan == 'RUPIAH'">Rp. {{
                        data.item.potongan ? data.item.potongan.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : '0' }},-</span>
                        <span v-else>-</span>
                    </div>
                    <div v-else class="font-weight-bold">{{ data.item.potongan }}</div>
                  </div>
                </template>
                <template v-slot:cell(subtotal_tarif_net)="data">
                  <div v-if="data.item.jenis_potongan !== '-'">
                    <div v-if="data.item.potongan == 'Diskon'">
                        <span v-if="data.item.jenis_potongan == 'PERSENTASE'">{{
                        data.item.subtotal_tarif_net > '0'
                        ? `${data.item.subtotal_tarif_net}%`
                        : '-'
                        }}</span>
                        <span v-else-if="data.item.jenis_potongan == 'RUPIAH'">{{
                        data.item.subtotal_tarif_net > '0'
                        ? `Rp. ${data.item.subtotal_tarif_net ? data.item.subtotal_tarif_net.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : '0'},-`
                        : '-'
                        }}</span>
                        <span v-else>{{
                        data.item.subtotal_tarif_net > '0'
                        ? `Rp. ${data.item.subtotal_tarif_net ? data.item.subtotal_tarif_net.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : '0'},-`
                        : '-'
                        }}</span>
                    </div>
                    <div v-else>
                        Rp. {{ data.item.subtotal_tarif_net ? data.item.subtotal_tarif_net.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : '0' }},-
                    </div>
                  </div>
                </template>
            </b-table>
            <img fluid v-if="dataStruk.status == 'LUNAS'" class="pembayaran-status" :src="require('@/assets/lunas.png')">
            <img fluid v-else class="pembayaran-status" :src="require('@/assets/belum-lunas.png')">
            <b-row class="mt-3">
                <b-col cols="4">
                    <p style="font-size:0.9em;" class="mb-0" v-for="data in [
                    `Created by: ${labelStartCase(dataStruk.kasir)}`,
                    `Created time: ${dataStruk.created_time}`,
                    `Admission time: ${dataStruk.admission_time}`,
                    `Discharged time: ${dataStruk.discharge_time}`
                    ]" :key="data">
                        {{ data }}
                    </p>
                </b-col>
                <b-col cols="4" class="text-center">
                    <small class="font-weight-bold">Powered by:</small> <br>
                    <img :src="require('@/assets/izidok.png')" width="100" alt="izidok">
                </b-col>
                <b-col cols="4"></b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import startCase from "lodash/startCase"

export default {
    data: () => ({
      layananNormal: [],
      obatBpjs: [],
      tindakanBpjs: [],
      isBpjs: false
    }),
    props: ['dataStruk','details','klinik', 'isDpm'],
    watch: {
      dataStruk: {
        deep: true,
        handler(val) {
          this.isBpjs = val.kategori == 'BPJS' ? true : false;
          this.getLayananType();
        }
      }
    },
    mounted() {

    },
    methods: {
        getLayananType() {
          this.layananNormal = []
          this.obatBpjs = []
          this.tindakanBpjs = []

          let rawDataLength = this.details.length;

          let data = this.details.slice(0, rawDataLength - 3);
          let calculateTarif = this.details.slice(-3);

          data.forEach((item) => {
            // set default to 0 if null attribute
            item.subtotal_tarif = item.subtotal_tarif || 0,
            item.subtotal_tarif_net = item.subtotal_tarif_net || 0,
            item.tarif = item.tarif || 0

            if (item.from_bpjs == 0) {
              this.layananNormal.push(item);
            } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 0) {
              this.tindakanBpjs.push(item);
            } else if(item.from_bpjs == 1 && item.bpjs_sk_type == 1) {
              this.obatBpjs.push(item);
            }
          })


          // not essential, only use to add "-" if layananNormal empty
          if(this.layananNormal.length == 0) {
            this.layananNormal.push({
              jenis_potongan: '-',
            })
          }

          this.layananNormal = [
            ...this.layananNormal,
            ...calculateTarif
          ];
        },
        fields() {
            return [
                { key: 'layanan', label: "Layanan/Obat/Bahan Habis Pakai", thStyle: 'width: 50%' },
                { key: "quantity", label: "QTY" },
                { key: "tarif", label: "Harga" },
                { key: "jenis_potongan", label: "Diskon" },
                { key: "potongan", label: "Nilai Diskon" },
                { key: "subtotal_tarif_net", label: "Sub Total (Rp)" },
            ]
        },
        fieldsTindakanBpjs() {
          return [
                { key: 'tindakan', label: "Tindakan", thStyle: 'width: 50%' },
                { key: "quantity", label: "QTY", thStyle: 'width: 10%' },
                { key: "tarif", label: "Tarif", thStyle: 'width: 20%' },
                { key: "subtotal_tarif_net", label: "Sub Total (Rp)", thStyle: 'width: 20%' },
            ]
        },
        fieldsObatBpjs() {
          return [
                { key: 'obat', label: "Obat", thStyle: 'width: 50%' },
                { key: "quantity", label: "QTY", thStyle: 'width: 10%' },
                { key: "sedia", label: "Sedia", thStyle: 'width: 20%' },
                { key: "subtotal_tarif_net", label: "Sub Total (Rp)", thStyle: 'width: 20%' },
            ]
        },
        cekNilaiDiskon(val) {
            let cek = true
            if(val == 'Total' || val == 'Total Dibayar Pasien' || val == 'Diskon' || val == 'Total Nett') cek = false
            return cek
        },
        labelStartCase(val) {
            return startCase(val)
        },
        labelMetodePembayaran(data) {
            if (this.isBpjs) {
                const checkAllBPJS = data.detail.filter((d) => d.from_bpjs == 0);
                if (checkAllBPJS.length > 0) {
                  if (data.nama_bank && data.nama_rekening) {
                      return `${data.jenis_pembayaran} (${data.nama_bank.toUpperCase()}-${data.nama_rekening})`;
                  } else {
                      return data.jenis_pembayaran;
                  }
                } else {
                    return 'BPJS';
                }
            } else {
                if (data.nama_bank && data.nama_rekening) {
                    return `${data.jenis_pembayaran} (${data.nama_bank}-${data.nama_rekening})`;
                } else {
                    return data.jenis_pembayaran;
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .pembayaran-status {
      position: absolute;
      top: 50%;
      left: 30%;
    }
    .struk-pembayaran {
      zoom: 90%;
    }
  
    .img-logo {
        height: 100px;
        border-radius: 10px;  
    }

     .mt-50 {
        margin-top: 50px;
      }

      .mb-50 {
        margin-bottom: 50px;
      }

      .mt-100 {
        margin-top: 100px;
      }
  </style>
  
  <style lang="scss">
    .table {
      &.table-pembayaran-struk {
        thead {
          th {
            background-color: #4896e8 !important;
            color: #ffffff !important;
            text-transform: none;
          }
        }
      }
    } 
    .modal-backdrop {
      opacity: 0.5 !important;
    }  
    @page {
      size: auto;
      margin: 0;
    }
    @media print {
      body {
        background-color: transparent !important;
      }
      div.app-main {
        background-color: transparent !important;
      }
      div.app-content {
        background-color: transparent !important;
      }
      div.app-header {
        display: none !important;
      }
      div.app-sidebar {
        display: none !important;
      }
      div.app-footer {
        display: none !important;
      }
      div.app-content {
        margin: 0;
        padding-top: 1rem !important;
      }
      .btn-struk {
        display: none !important;
      }
      .pembayaran-status {
        position: absolute;
        top: 52% !important;
        left: 20% !important;
      }
      .table {
        &.table-pembayaran-struk {
          thead {
            th {
              background-color: #4896e8 !important;
              -webkit-print-color-adjust: exact;
            }
          }
        }
      }
    }
  </style>